import styled from 'styled-components'
import { G } from '@/components/gold/theme'

/**
 * ver2(gold) 모바일 게임사 목록 — m.gold8.bet 실측(390px 화면 기준):
 *   어두운 판(둥근 모서리 10px) 안에 3열, 가로 간격 15px·세로 간격 20px, 타일 테두리 금색.
 */
export const Panel = styled.div`
  margin: 0 9px;
  padding: 14px 12px 24px;
  border-radius: 10px;
  background: ${G.mPanel};
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 15px;
`

export const Tile = styled.button`
  display: block;
  width: 100%;
  aspect-ratio: 230 / 205;
  padding: 0;
  border: 1.5px solid #f2e08a;
  background: #11161c;
  overflow: hidden;
  cursor: pointer;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 모바일 썸네일(메뉴 설정 「모바일 썸네일」)이 있으면 가운데, 없으면 PC 가로 그림이라 로고가 있는 오른쪽을 보인다 */
    object-position: ${({ $mobileThumb }) => ($mobileThumb ? 'center' : '75% center')};
  }
`
